<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.proId" placeholder="请选择项目名称" clearable filterable @change="changeSizes">
            <el-option
            v-for="item in optionsProject"
            :key="item.proId"
            :label="item.proName"
            :value="item.proId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">尺寸：</span>
        <el-select v-model="search.size" placeholder="请选择尺寸" clearable>
            <el-option
                v-for="item in optionsSize"
                :key="item.sizeId"
                :label="item.sizeName"
                :value="item.sizeId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">配筋：</span>
        <el-select v-model="search.reinforcement" placeholder="请选择配筋" clearable>
            <el-option
                v-for="item in optionsHass"
                :key="item.hasSteel"
                :label="item.has"
                :value="item.hasSteel">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBtn">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column :prop="item.prop" v-for="(item,index) in tableTitles" :key="index" :label="item.label" align="center" width="135"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="proId">
          <el-select v-model="ruleForm.proId" placeholder="请选择项目名称" @change="changeSizes" clearable>
                <el-option
                v-for="item in optionsProject"
                :key="item.proId"
                :label="item.proName"
                :value="item.proId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="尺寸：" prop="size">
          <el-select v-model="ruleForm.size" placeholder="请选择尺寸" >
            <el-option
                v-for="item in optionsSize"
                :key="item.sizeId"
                :label="item.sizeName"
                :value="item.sizeId">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="配筋：" prop="reinforcement">
          <el-select v-model="ruleForm.reinforcement" placeholder="请选择配筋">
            <el-option
                v-for="item in optionsHass"
                :key="item.hasSteel"
                :label="item.has"
                :value="item.hasSteel">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="块号：" prop="blockNum">
          <el-select v-model="ruleForm.blockNum" placeholder="请选择块号">
            <el-option
                v-for="item in optionsBlocks"
                :key="item.blockNum"
                :label="item.blockName"
                :value="item.blockNum">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="height:300px">
            <el-table
                v-loading="loadingForm"
                :data="rawList"
                height="100%"
                :header-cell-style="() => 'background-color: #082F57; color: #39B5FE'">
                <el-table-column align="center" label="序号" width="60">
                <template #default="scope">
                    <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
                </template>
                </el-table-column>
                <el-table-column prop="materialNameCn" label="原料名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="重量" align="center" show-overflow-tooltip>
                    <template #default="{row}">
                        <el-input 
                            v-model="row.materialValue" 
                            :size="size"
                            type="number"
                            placeholder="请输入">
                            <template slot="append">吨</template>
                        </el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize,downLoadFile } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        loadingForm:false,
        rowId:'',//某一行id
        dataList: [], //管片原料理论放量信息
        tableTitles:[],//表头名称
        optionsProject:[],//项目名称
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {}, // 按钮表单
        rules: {
          proId: [{
            required: true,
            message: '请选择项目名称',
            trigger: 'change'
          }],
          size: [{
            required: true,
            message: '请选择尺寸',
            trigger: 'change'
          }],
          reinforcement: [{
            required: true,
            message: '请选择配筋',
            trigger: 'change'
          }],
          blockNum: [{
            required: true,
            message: '请选择块号',
            trigger: 'change'
          }],
        },
        optionsSize:[],//尺寸
        optionsHass:[],//配筋
        optionsBlocks:[],//块号
        rawList:[],//弹框中的原料数据
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllProjects()
      // that.getPlanRaw()
    },
    methods: {
      //导出按钮
      exportBtn(){
        let params = Object.assign({},this.search)
        this.$api.Ducts.exportBtns(params).then(res=>{
            if(res.statusMsg ==='ok'){
                downLoadFile(res.data,'/materials/rsbMaterialPlan/export')
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      //获取计划原料列表
      getPlanRaw(){
        this.loadingForm = true
        this.$api.Ducts.getPlanList({}).then(res=>{
            if(res.statusMsg==='ok'){
                this.rawList = res.data
                this.loadingForm = false
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      //通过选择项目选择尺寸
     changeSizes(val){
      this.$api.Reinforce.searchProjectSize({proId:val,pageNum: 1,
          pageSize:100000000}).then(res=>{
        if(res.statusMsg === 'ok'){
          if(val ===""){
            this.optionsSize = []
            this.search.size = ""
            this.search.reinforcement = ""
            this.$set(this.ruleForm,'size','')
            this.$set(this.ruleForm,'reinforcement','')
            this.$set(this.ruleForm,'blockNum','')
          }else{
            this.optionsSize = res.data.list
          }
        }else{
            this.$message.warning(res.statusMsg)
        }
      })
      this.$api.Reinforce.searchProjectBears({proId:val,pageNum: 1,
          pageSize:1000000}).then(res=>{
        if(res.statusMsg === 'ok'){
            this.optionsHass = res.data.hasDtos
            this.optionsBlocks = res.data.blokDtos
        }else{
            this.$message.warning(res.statusMsg)
        }
      })
     },
     //获得所有项目名称
     getAllProjects(){
        let obj = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Engineer.searchProjects(obj).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsProject = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Ducts.searchDuctRaw(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.pageInfo.total;
            this.dataList = res.data.pageInfo.list;
            let titles = []
            titles =res.data.tableHeader.map(item=>{
                return{
                    label:item.headName+'(吨)',
                    prop:item.fieldName
                }
            })
            this.tableTitles = [{
                label:"项目名称",
                prop:"proName"
            },{
                label:"尺寸",
                prop:"sizeName"
            },{
                label:"配筋",
                prop:"reinforcementName"
            },{
                label:"块号",
                prop:"blockNumName"
            },...titles,{
                label:"创建人",
                prop:"createUserName"
            },{
                label:"创建时间",
                prop:"createTime"
            }]
            this.loading = false;
          }else{
            this.$message.warning(res.statusMsg)
          }
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.getPlanRaw()
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.ruleForm = row
        this.rowId = row.id
        this.$api.Reinforce.searchProjectSize({proId:row.proId,pageNum: 1,
          pageSize:100000000}).then(res=>{
        if(res.statusMsg === 'ok'){
          if(this.ruleForm.proId ===""){
            this.optionsSize = []
          }else{
            this.optionsSize = res.data.list
          }
        }else{
            this.$message.warning(res.statusMsg)
        }
      })
      this.$api.Reinforce.searchProjectBears({proId:row.proId,pageNum: 1,
          pageSize:1000000}).then(res=>{
        if(res.statusMsg === 'ok'){
            this.optionsHass = res.data.hasDtos
            this.optionsBlocks = res.data.blokDtos
        }else{
            this.$message.warning(res.statusMsg)
        }
      })
        this.$api.Ducts.getPlanList({id:row.id}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.rawList = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Ducts.deleteDuctRaw({id: row.id})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.materialsList = this.rawList
            this.$api.Ducts.insertDuctRaw(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.materialsList = this.rawList
            this.$api.Ducts.updateDuctRaw(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>